<template>
    <div>
        <div
            class="mt-input mt-input--growable"
            :class="{ disabled, active, filled }"
            @click="
                active = true;
                $emit('click', $event);
            "
        >
            <input type="text" @focus="active = true" v-if="!active" class="focusInput" />
            <div v-if="coins" class="coins">{{ coins }}</div>
            <div v-if="label" class="label" :class="{ 'hold-place': !filled }">
                {{ label }}<span class="required" v-if="required">&nbsp;&nbsp;*</span>
            </div>

            <div class="mt-input__value-wrapper">
                <!-- @click="active = !active" -->
                <div class="mt-input__value-wrapper__arrow drop-arrow"></div>
                <template v-for="(val, index) in value">
                    <div :key="index" class="chip">
                        <span class="text">{{
                            itemText
                                ? selected.find((s) => s[itemValue] == (useObject ? val[itemValue] : val))
                                    ? selected.find((s) => s[itemValue] == (useObject ? val[itemValue] : val))[itemText]
                                    : ''
                                : val
                        }}</span>
                        <span class="close" @click.stop="removeItem(index)"></span>
                    </div>
                </template>
            </div>

            <div class="mt-input__select" v-if="active">
                <div v-if="!hideSearch" class="head">
                    <div class="search">
                        <font-awesome-icon class="icon" icon="search" />
                        <input
                            class="mt-input__value"
                            type="text"
                            ref="vinput"
                            @input="inputf"
                            @blur="blurClose"
                            autocomplete="off"
                        />
                    </div>
                </div>

                <div v-loading="debounceLoading && !hideDebounceLoading" class="body">
                    <div
                        v-if="searchValue.length === 0 && noInputText && search.length === 0"
                        class="mt-input__select__item mt-input__select__item--empty"
                    >
                        {{ noInputText }}
                    </div>
                    <div
                        v-else-if="searchValue.length > 0 && noResultText && search.length === 0"
                        class="mt-input__select__item mt-input__select__item--empty"
                    >
                        {{ noResultText }}
                    </div>
                    <div
                        class="mt-input__select__item mt-input__select__item--icon"
                        v-for="item in search"
                        :key="itemValue ? item[itemValue] : Math.random()"
                        :class="{
                            selected:
                                selected.findIndex((s) => {
                                    if (itemValue) {
                                        return s[itemValue] == item[itemValue];
                                    } else {
                                        return item == s;
                                    }
                                }) > -1,
                        }"
                        @mousedown.prevent="selectValue($event, item)"
                    >
                        <div>{{ itemText ? item[itemText] : item }}</div>
                        <div class="icon icon--check"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import debounce from '@/tools/debounce';

export default {
    name: 'ModelMultiAutoComplete',
    props: {
        label: String,
        items: {
            type: Array,
            default: () => [],
        },
        value: [Array, Object],
        selected: {
            type: Array,
            default: () => [],
        },
        search: {
            type: Array,
            default: () => [],
        },
        coins: Number,
        disabled: Boolean,
        itemValue: String,
        itemText: String,
        required: {
            type: Boolean,
            default: false,
        },
        noInputText: {
            type: String,
            default: () => '',
        },
        noResultText: {
            type: String,
            default: () => '',
        },
        useObject: {
            type: Boolean,
            default: false,
        },
        hideSearch: {
            type: Boolean,
            default: false,
        },
        hideDebounceLoading: {
            type: Boolean,
            default: false,
        },
    },
    model: {
        prop: 'value',
        event: 'change',
    },
    data: () => ({
        searchValue: '',
        active: false,
        beforeInput: false,
        debounceLoading: false,
    }),
    computed: {
        filled() {
            return this.active || (this.selected && this.selected.length) || (this.value && this.value.length);
        },
    },
    watch: {
        active(v) {
            if (v) {
                this.$nextTick(() => {
                    if (this.$refs.vinput) {
                        this.$refs.vinput.focus();
                    }
                });
            }
        },
    },
    methods: {
        selectValue($event, item) {
            let index = this.selected.findIndex((s) => {
                if (this.itemValue) {
                    return s[this.itemValue] == item[this.itemValue];
                } else {
                    return item == s;
                }
            });
            if (index >= 0) {
                this.removeItem(index);
            } else {
                this.emitValue($event, item);
            }
        },
        completeInputs: debounce(function (e) {
            this.$emit('debounce-end', {
                value: e.target.value,
            });
            this.searchValue = e.target.value;
            this.debounceLoading = false;
        }, 1000),
        inputf(e) {
            this.debounceLoading = true;
            this.completeInputs(e);
            this.$emit('no-debounce', {
                value: e.target.value,
            });
        },
        emitValue(e, item) {
            if (
                !this.selected ||
                (!!this.selected && this.selected.indexOf(this.itemValue ? item[this.itemValue] : item) === -1)
            ) {
                this.selected.push(item);
                this.$emit(
                    'change',
                    this.selected.map((s) => (this.itemValue && !this.useObject ? s[this.itemValue] : s))
                );
            }
        },
        blurClose() {
            setTimeout(() => {
                this.active = false;
            }, 350);
        },
        removeItem(index) {
            this.selected.splice(index, 1);
            this.$emit(
                'change',
                this.selected.map((s) => (this.itemValue && !this.useObject ? s[this.itemValue] : s))
            );
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';
@import '~@/styles/mt';
@import '~@/styles/mrem';
/*activate checkbox regExp in finder of phpStorm*/
/*find      {: ([0-9]*)px}*/
/*replace   {: rem($1);}*/
input {
    font-family: 'Open Sans', sans-serif;
}

.focusInput {
    width: 0;
    height: 0;
    padding: 0;
    position: absolute;
}

@mixin custom-scroll-bar {
    &::-webkit-scrollbar {
        height: auto;
        width: 0.3rem;
    }

    &::-webkit-scrollbar-thumb {
        background: #e1e1e1;
        border-radius: 0.3rem;
    }

    &::-webkit-scrollbar-track {
        background: none;
    }
}

.drop-arrow {
    top: 50% !important;
    transform: translateY(-50%) !important;
}

.arrow {
    margin-right: 0.2rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    .icon {
        background: no-repeat center/50% url(../../../assets/images/UI/drop.svg);
        width: rem(20);
        height: rem(20);
    }

    .clicked {
        transform: rotate(90deg);
    }
}

.data-model {
    height: auto;
    min-height: rem(40);
}

.open-multiply {
    z-index: 20;
    position: absolute;
    right: rem(8);
    top: rem(10);

    .open {
        display: block;
        content: ' > ';
        transform: rotate(90deg) scaleY(2);
    }
}

.multiply-values {
    height: 100%;
}

.multiply-values div {
    float: left;
    position: relative;
    background-color: #e3edff;
    border-radius: rem(4);
    padding: rem(5) rem(20) rem(5) rem(5);
    margin-right: rem(25);
    margin-top: rem(6);
    font-size: rem(14);
}

.multiply-values div .remove {
    font-weight: 800;
    height: 100%;
    width: rem(18);
    display: inline-block;
    text-align: center;
    position: absolute;
    right: 2px;
    top: 15%;
}

.input-wrapper {
    height: 100%;
    cursor: pointer;
    border-radius: 0.2rem;
    /*border: rem(1) solid #98A0A9;*/
    width: 100%;
    /*height: 2.5rem;*/
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: rem(10) 0 rem(10) 0;

    .input-name {
        position: absolute;
        top: -0.4rem;
        left: 0.5rem;
        background: white;
        padding-left: 0.3rem;
        padding-right: 0.3rem;
        font-size: 0.6rem;
        font-weight: 600;
        color: #98a0a9;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
    }

    .valueField {
        border: none;
        display: flex;
        height: 100%;
        width: 100%;
        background: none;
        padding-left: 0.8rem;
        padding-right: 0.8rem;
        font-size: 0.8rem;
        position: relative;
        align-items: center;

        .formLay {
            width: 100%;
            height: 100%;
        }
    }
}

.values {
    font-size: 0.8rem;
    position: absolute;
    left: calc(0rem - 1px);
    width: 100%;
    z-index: 22;
    background: white;
    border-right: rem(1) solid #98a0a9;
    border-left: rem(1) solid #98a0a9;
    border-bottom: rem(1) solid #98a0a9;
    border-radius: 0.2rem;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    box-sizing: content-box;

    input {
        display: block;
        height: 100%;
        width: 100%;
        background: none;
        font-size: 0.8rem;
        padding: 7px 7px 7px 35px;
        margin-top: 15px;
        border: 1px solid #d2d5d9;
    }

    .list {
        box-sizing: content-box;
        max-height: 15rem;
        overflow-y: scroll;
        @include custom-scroll-bar;

        .selectorItems {
            width: 100%;
            height: auto;
            display: flex;
            padding-top: 0.3rem;
            padding-bottom: 0.3rem;
            padding-left: 0.8rem;
            margin-top: 0.2rem;
            margin-bottom: 0.2rem;
            padding-right: 0.8rem;
            align-items: center;
            color: black;

            &:hover {
                background: #f7f7f8;

                .icon {
                    color: #98a0a9;
                }
            }

            .icon {
                min-width: rem(24);
                color: #4663ab;
            }
        }
    }
}

@import '../../../styles/variables';
@media (max-width: $vm) {
    .arrow {
        margin-right: mrem(10);

        .icon {
            width: mrem(20);
            height: mrem(20);
        }
    }

    .drop-arrow {
        top: mrem(11) !important;
    }

    .data-model {
        height: auto;
        min-height: mrem(40);
        border: mrem(1) solid #d2d5d9;
        border-radius: mrem(4);

        .label {
            font-size: mrem(11);
            line-height: mrem(16);
            top: mrem(-9);
            left: mrem(14);
            z-index: 8;
        }

        .label.hold-place {
            top: mrem(10);
            left: mrem(14);
            color: #98a0a9;
            font-size: mrem(16);
            z-index: 8;
        }

        .label.hold-place.invalid {
            color: red;
        }

        .input-wrapper {
            input {
                font-size: mrem(16);
                padding: mrem(11) mrem(13);
            }

            .values {
                font-size: mrem(14);
                border: mrem(1) solid #d2d5d9;
                max-height: mrem(120);
                margin-top: mrem(30);

                .selectorItems {
                    padding: mrem(10);
                }
            }
        }
    }

    .open-multiply {
        right: mrem(0);
        top: mrem(8);
        font-size: mrem(18);
    }

    .multiply-values div {
        border-radius: mrem(4);
        padding: mrem(5) mrem(20) mrem(5) mrem(5);
        margin-right: mrem(20);
        margin-top: mrem(6);
        font-size: mrem(14);
    }

    .multiply-values div .remove {
        width: mrem(18);
        right: mrem(2);
        top: 15%;
    }

    .search {
        position: relative;
        padding-bottom: 0.3rem;
        padding-left: mrem(12);
        margin-top: mrem(5);
        margin-bottom: mrem(5);
        padding-right: mrem(12);

        .icon {
            top: mrem(10);
            left: mrem(25);
        }
    }

    .input-wrapper {
        min-height: mrem(40);
        height: 100%;
        cursor: pointer;
        border-radius: 0.2rem;
        padding: mrem(10) 0 mrem(10) 0;

        .input-name {
            top: -0.4rem;
            left: 0.5rem;
            background: white;
            padding-left: 0.3rem;
            padding-right: 0.3rem;
            font-size: mrem(12);
        }

        .valueField {
            border: none;
            display: flex;
            height: 100%;
            width: 100%;
            background: none;
            padding-left: mrem(12);
            padding-right: mrem(12);
            font-size: mrem(12);
            position: relative;
            align-items: center;

            .formLay {
                width: 100%;
                height: 100%;
            }
        }
    }

    .values {
        font-size: mrem(14);
        position: absolute;
        left: calc(0rem - 1px);
        border-right: mrem(1) solid #d2d5d9;
        border-left: mrem(1) solid #d2d5d9;
        border-bottom: mrem(1) solid #d2d5d9;
        border-radius: 0.2rem;

        input {
            display: block;
            height: 100%;
            width: 100%;
            background: none;
            font-size: mrem(14);
            padding: mrem(7) mrem(7) mrem(7) mrem(35);
            margin-top: mrem(15);
            border: mrem(1) solid #d2d5d9;
        }

        .list {
            box-sizing: content-box;
            max-height: mrem(200);
            overflow-y: scroll;
            @include custom-scroll-bar;

            .selectorItems {
                width: 100%;
                padding-top: 0.3rem;
                padding-bottom: 0.3rem;
                padding-left: mrem(12);
                margin-top: mrem(5);
                margin-bottom: mrem(5);
                padding-right: mrem(12);

                .icon {
                    min-width: mrem(24);
                    color: #4663ab;
                }
            }
        }
    }
}

.mt-input__select {
    z-index: 10;
}

.mt-input__select__item--empty {
    color: $color-main-blue;
    background: $color-main-primary-light;
    width: calc(100% - #{mrem(28)});
    border-radius: mrem(16);
    padding: mrem(14);
    margin: mrem(14);
    border: mrem(1) solid $color-main-blue;

    @include on-desktop {
        width: calc(100% - #{rem(28)});
        border-radius: rem(16);
        padding: rem(14);
        margin: rem(14);
        border: rem(1) solid $color-main-blue;
    }
}
.mt-input--growable .mt-input__select .body {
    min-height: auto;
}
</style>
